export const fetchConnections = ({ wsApi, clientToken }) => {
  const clientTokenParam = clientToken ? `?token=${encodeURI(clientToken)}` : '';

  return fetch(
    `${wsApi}/connect${clientTokenParam}`,
    { headers: { Accept: 'application/json' } }
  ).then((res) => res.json());
}
